import { config } from '@config';

const MISSION_ASSESSMENT_AI_BASE_URL = `${config.api.baseUrl}/v1/expert/mission-assessments`;

/**
 * Single source of truth for the expert Mission Assessment AI endpoints, so the
 * route strings are not re-declared across every generation surface.
 */
export const MISSION_ASSESSMENT_AI_ENDPOINTS = {
  chat: `${MISSION_ASSESSMENT_AI_BASE_URL}/chat`,
  generate: `${MISSION_ASSESSMENT_AI_BASE_URL}/generate`,
} as const;
